/* eslint-disable react/no-unknown-property */
/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import MuiButton from '@mui/material/Button';
import Text from '@Text';
import { useWidgetHeightRefresh } from '../../Hooks/useWidgetHeightRefresh/useWidgetHeightRefresh';
import makeSlotPickerStyles from './makeSlotPickerStyles';
import makeAppointmentAccordionStyles from './makeAppointmentAccordionStyles';

// Matches the expand/collapse grid-template-rows transition in makeSlotPickerStyles.
export const EXPAND_TRANSITION_MS = 350;

const AppointmentAccordion = ({ label, body, onToggle }) => {
  const theme = useTheme();
  const collapseClasses = makeSlotPickerStyles({ theme });
  const classes = makeAppointmentAccordionStyles({ theme });
  const [isOpen, setIsOpen] = useState(false);

  // Re-check the widget height after the expand/collapse animation settles, so
  // the widget grows and shrinks with the accordion instead of sticking.
  useWidgetHeightRefresh([isOpen], EXPAND_TRANSITION_MS + 50);

  const handleToggle = () => {
    setIsOpen((current) => !current);
    onToggle?.();
  };

  return (
    <Box css={classes.accordion} data-testid="appointmentAccordion">
      <MuiButton
        css={[classes.accordionToggle, isOpen && classes.accordionToggleOpen]}
        onClick={handleToggle}
        aria-expanded={isOpen}
        data-testid="appointmentAccordionToggle"
      >
        <Text variant="text">{label}</Text>
        <span css={[classes.chevron, isOpen && classes.chevronOpen]}>›</span>
      </MuiButton>
      <Box
        css={[
          collapseClasses.expandable,
          isOpen && collapseClasses.expandableOpen,
        ]}
      >
        <Box css={collapseClasses.expandableInner}>
          <Box
            css={classes.accordionBody}
            data-testid="appointmentAccordionBody"
          >
            <Text variant="text">{body}</Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AppointmentAccordion;
